const renderParticipationModal = () => {
   const pageBody = document.querySelector('body');
   const participationModal = document.querySelector('.participation__modal');
   const modalTitle = participationModal?.querySelector('h2');
   const participateList = participationModal?.querySelector('.participation__rules-list--participate');
   const documentsList = participationModal?.querySelector('.participation__rules-list--documents');

   const onCardClick = (evt) => {
      if (evt.target.closest('[data-modal-id="participation-modal"]')) {
         const targetCard = evt.target.closest('.participation__slide');
         const participateRules = Array.from(targetCard.querySelectorAll('.participation__slide-rules li')).map((rule) => rule.outerHTML);
         const documents = Array.from(targetCard.querySelectorAll('.participation__slide-documents li')).map((document) => document.outerHTML);         

         modalTitle.textContent = targetCard.querySelector('.participation__slide-info p').textContent;
         participateList.innerHTML = participateRules.join(' ');
         documentsList.innerHTML = documents.join(' ');
      }
   };

   participationModal && pageBody.addEventListener('click', onCardClick);
};

export default renderParticipationModal;
